import { FilePdfIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Pdf = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <FilePdfIcon {...rest} size={Sizes[size]} color={fill} />;
};

Pdf.displayName = 'Pdf';
